export const GET_PERFORMANCE_TEST_RESULT = "GET_PERFORMANCE_TEST_RESULT";
export const GET_PERFORMANCE_TEST_RESULT_LOADING =
  "GET_PERFORMANCE_TEST_RESULT_LOADING";
export const GET_PERFORMANCE_TEST_RESULT_SUCCESS =
  "GET_PERFORMANCE_TEST_RESULT_SUCCESS";
export const GET_PERFORMANCE_TEST_RESULT_ERROR =
  "GET_PERFORMANCE_TEST_RESULT_ERROR";

export const GET_ALL_USER_TEST_RESULT = "GET_ALL_USER_TEST_RESULT";
export const GET_ALL_USER_TEST_RESULT_LOADING =
  "GET_ALL_USER_TEST_RESULT_LOADING";
export const GET_ALL_USER_TEST_RESULT_SUCCESS =
  "GET_ALL_USER_TEST_RESULT_SUCCESS";
export const GET_ALL_USER_TEST_RESULT_ERROR = "GET_ALL_USER_TEST_RESULT_ERROR";
